import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DtcSibling } from '../../../../shared/models/dtc/dtc-sibling';
import { BaseReviewRequestPropagationModal } from './base-review-request-propagation-modal';
import { AgentActionDirective } from '../../../directives/agent-action.directive';

@Component({
  selector: 'app-approve-dtc-propagation-modal',
  imports: [AgentActionDirective],
  templateUrl: './propagation-modal.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './propagation-modal.scss',
})
export class ApproveDtcSiblingsModal extends BaseReviewRequestPropagationModal {
  protected reviewerRole?: string;

  public override openModal(entityId?: string, dtcSiblings?: DtcSibling[], reviewerRole?: string): void {
    this.reviewerRole = reviewerRole;
    this.callToActionDescription = 'You can approve siblings in other branches.';
    this.additionalInfoText =
      'Note: The approval can only be transferred to siblings with matching documentation fields. It is not possible to transfer it to siblings with diverging reviews.';
    super.openModal(entityId, dtcSiblings);
    this.businessObject = 'dtc';
  }

  protected execute(): void {
    if (!this.selectedOptionIds || this.selectedOptionIds.length < 1) {
      console.log('No SW Part Numbers selected for approving siblings');
      return;
    }

    this.reviewRequestApi
      .approveDtcSiblings(this.mapSelectedSwPartNumbersToTargets(), this.reviewerRole ?? '')
      .subscribe({
        next: () => {
          this.toast.success('Successfully approved siblings for other SW Part Numbers');
          this.closeModal();
        },
        error: (err) => {
          console.log(err);
          this.toast.error('Failed to approve siblings for other SW Part Numbers');
        },
      });
  }
}
